import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const ScrollBackToTopContainer = styled.div`
  position: fixed;
  bottom: 25px;
  right: 25px;
  width: 52px;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.white};
  border: 1px solid ${colors.textSecondary};
  box-sizing: border-box;
  border-radius: 26px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  transition: ease-in-out .2s;
  opacity: ${prop => prop.show ? '1' : '0'};
  cursor: pointer;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    -webkit-box-shadow: 0px 5px 15px ${colors.shadowHover};
    -moz-box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

